import { useFieldArray, useFormContext } from 'react-hook-form'

import { DependentInfoEntry } from 'components/quoting/quotes/employee_entry/DependentInfoEntry'
import { TextButton } from 'slab'

type Props = {
  employeeIndex: number
}

export function DependentsEditor ({ employeeIndex }: Props) {
  const { control } = useFormContext()
  const { fields, append, remove } = useFieldArray({ control, name: `employees.${employeeIndex}.dependents` })

  return (
    <div className='flex flex-col gap-4'>
      {fields.map((field, dependentIndex) => (
        <DependentInfoEntry
          key={field.id}
          employeeIndex={employeeIndex}
          dependentIndex={dependentIndex}
          onRemove={() => remove(dependentIndex)}
        />
      ))}
      <div>
        <TextButton
          color='gray'
          onClick={() => append({ relationship: 'spouse', date_of_birth: '' })}
        >
          Add dependent
        </TextButton>
      </div>
    </div>
  )
}
